





















interface LocalProps {
  value: PropOptions;
  disabled: PropOptions;
  styleType: PropOptions<StyleType>;
}

import Vue, { PropOptions } from 'vue';
import StyleType from '@/core/typings/enums/StyleType';

export default Vue.extend({
  name: 'HMCheckBox',
  computed: {
    uid() {
      return this._uid;
    },
  },
  props: {
    value: {
      type: Boolean,
      default: true,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    styleType: {
      type: String,
      default: StyleType.SQUARE,
    },
  } as LocalProps,
  methods: {
    emitValue($event) {
      $event.preventDefault();
      $event.stopPropagation();
      this.$emit('input', !this.value);
    },
  },
});
